export function between(parameters) {
  const [min, max] = parameters;
  return {
    min,
    max
  };
}
